import { createService } from "./serviceFactory";

export const dietaryService = createService("dietary-restrictions");
